import { c as _c } from "react/compiler-runtime";
import { gql, useQuery } from '@material-bank/graphql-client';
import { isSettled } from '../utils/isSettled';
export const PAIRS_WITH_PRODUCTS_PER_PAGE = 50;
export const PAIRS_WITH_PRODUCTS_QUERY = gql`
  query PairsWithProducts(
    $sku: String!
    $resultsPerPage: Int
    $locale: String
  ) {
    pairsWithProducts(
      sku: $sku
      resultsPerPage: $resultsPerPage
      locale: $locale
    ) {
      products {
        id
        name
        brand
        imageUrl
        installImageUrl
        groupId
        category
        searchHexCode
      }
      totalCount
    }
  }
`;
export type PairsWithProduct = {
  id: string;
  name: string;
  brand: string | null;
  imageUrl: string;
  installImageUrl: string | null;
  groupId: string | null;
  category: string;
  searchHexCode: string | null;
};
export type PairsWithProductsResult = {
  products: PairsWithProduct[];
  totalCount: number;
};
type PairsWithProductsQueryData = {
  pairsWithProducts: PairsWithProductsResult;
};
type PairsWithProductsQueryVars = {
  sku: string;
  resultsPerPage?: number | null;
  locale?: string | null;
};
export function usePairsWithProductsQuery(options) {
  const $ = _c(13);
  const t0 = useQuery(PAIRS_WITH_PRODUCTS_QUERY, options);
  let data;
  let networkStatus;
  let previousData;
  let rest;
  if ($[0] !== t0) {
    ({
      data,
      previousData,
      networkStatus,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = data;
    $[2] = networkStatus;
    $[3] = previousData;
    $[4] = rest;
  } else {
    data = $[1];
    networkStatus = $[2];
    previousData = $[3];
    rest = $[4];
  }
  const t1 = data?.pairsWithProducts;
  const t2 = previousData?.pairsWithProducts;
  let t3;
  if ($[5] !== networkStatus) {
    t3 = isSettled(networkStatus);
    $[5] = networkStatus;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== networkStatus || $[8] !== rest || $[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t4 = {
      data: t1,
      previousData: t2,
      networkStatus,
      settled: t3,
      ...rest
    };
    $[7] = networkStatus;
    $[8] = rest;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}